import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { errorFeatureKey, errorReducer } from './state/error.reducer';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		StoreModule.forFeature(errorFeatureKey, errorReducer),
	],
})
export class ErrorModule {}
